import {
  Box,
  SkeletonGroup,
  SkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';
import { FunctionComponent } from 'react';
import css from './index.module.scss';

export const SkeletonLoading: FunctionComponent = () => (
  <SkeletonGroup>
    <Box direction='vertical' gap='5'>
      <SkeletonRectangle className={css.header} />
      <Box direction='vertical' gap='3'>
        {[...Array(4)].map((_, index) => (
          <Box direction='vertical' key={index} gap='4'>
            <Box direction='vertical' >
              <Box gap='2'>
                <SkeletonRectangle className={css.category} />
                <SkeletonRectangle className={css.articleType} />
              </Box>
              <SkeletonLine className={css.articleTitle} />
              <Box className={css.descriptionAndTimeToRead} verticalAlign='middle'>
                <Box direction='vertical' gap='2'>
                  <SkeletonLine className={css.descriptionFirst} />
                  <SkeletonLine className={css.descriptionSecond} />
                </Box>
                <SkeletonLine className={css.timeToRead} />
              </Box>
            </Box>
            {index < 3 && <SkeletonRectangle className={css.separator} />}
          </Box>
        ))}
      </Box>
    </Box>
  </SkeletonGroup>
);
